import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Notifications from 'vue-notification'
Vue.use(Notifications)
import VueMeta from 'vue-meta'
Vue.use(VueMeta)
import axios from 'axios'
Vue.use(VueAxios, axios)
import VueAxios from 'vue-axios'
import money from 'v-money'
Vue.use(money, { precision: 4 })
import VueCurrencyFilter from 'vue-currency-filter'
Vue.use(VueCurrencyFilter, {
  symbol: '$',
  thousandsSeparator: '.',
  fractionCount: 0,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true
})
import VueQrcodeReader from "vue-qrcode-reader";
Vue.use(VueQrcodeReader);
import vmodal from 'vue-js-modal';
Vue.use(vmodal);
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAZMwJwfaZvYeySavSylW1JfOQMzn43OQM",
    libraries: "places",
  },
});
Vue.config.productionTip = false
Vue.prototype.$api_key = 'c628a195-14c7-4876-a678-0811cef53830'
//Vue.prototype.$base_url = 'https://arboledadev.com/reddy/api/index.php/'
//Vue.prototype.$base_url = 'https://reddycolombia.com/api/index.php/'
//Vue.prototype.$base_url = 'https://api.reddycolombia.com/index.php/'
//Vue.prototype.$base_url = 'https://reddytech.com.co/api/index.php/'
switch (process.env.NODE_ENV) {
  case "production":
    Vue.prototype.$base_url = 'https://reddytech.com.co/api/index.php/'
    break;
  default:
    Vue.prototype.$base_url = "https://reddytech.com.co/api/index.php/";
    break;
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
